import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const hideOnScroll = (header) => {
  ScrollTrigger.matchMedia({
    '(max-width: 1023px)': () => {
      gsap.to(header, {
        scrollTrigger: {
          scroller: '.smooth-scroll',
          trigger: 'main',
          scrub: true,
          start: 54,
          end: 1000000000000,
          toggleClass: {
            targets: header,
            className: 'top-navigation--sticky'
          }
        }
      })
    }
  })

  ScrollTrigger.matchMedia({
    '(min-width: 1024px)': () => {
      gsap.to(header, {
        scrollTrigger: {
          scroller: '.smooth-scroll',
          trigger: 'main',
          scrub: true,
          start: 120,
          end: 1000000000000,
          toggleClass: {
            targets: header,
            className: 'top-navigation--sticky'
          }
        }
      })
    }
  })
}
